// Game-module shim (unify Phase 3): resolves to the active game's SupabaseService.
import game from '../games';
const impl = game.id === 'mlbb'
  ? require('../games/mlbb/services/SupabaseService')
  : require('../games/dota/services/SupabaseService');
export default impl.default;
